// Development

// export const SERVER_URL = "http://localhost";
// export const SERVER_PATH = `${SERVER_URL}/shivamfarms_be/controllers/api/`;

export const SERVER_URL = "https://vebbox.in/vebcommerce";
export const SERVER_PATH = `${SERVER_URL}/be/controllers/api/`;
